import ModulesReducer from './reducers/modules-reducer';
import { configureStore } from '@reduxjs/toolkit';
import AuthInfoReducer from './reducers/authInfoReducer';
import ModuleRouteReducer from './reducers/module-route-info-reducer';
import ThemeReducer from './reducers/theme-reducer';
import { useDispatch } from 'react-redux';
import DataInstanceReducer from './reducers/DataInstanceReducer';
import notificationMessageReducer from './reducers/notificationMesageReducer';
import FormConfigReducer from './reducers/form-config-reducer';
import PrevContextReducer from './reducers/PrevContextReducer';
import RequiredFieldsReducer from './reducers/requiredFieldsReducer';
import { enableMapSet } from 'immer';
import DialogsViewsState from './reducers/dialogViewsReducer';
import PageViewsReducer from './reducers/pageViewsReducer';
import ViewStateLoadedReducer from './reducers/viewStateLoadedReducer';
import SidebarViewsStateReducer from './reducers/sidebarViewsReduser';
import themeEditorReducer from './reducers/themeEditorReducer';

enableMapSet();

const store = configureStore({
  reducer: {
    modules: ModulesReducer,
    authInfo: AuthInfoReducer,
    moduleRouteInfo: ModuleRouteReducer,
    theme: ThemeReducer,
    themeEditor: themeEditorReducer,
    dataInstance: DataInstanceReducer,
    notificationMessage: notificationMessageReducer,
    pageConfig: FormConfigReducer,
    prevContext: PrevContextReducer,
    formRequiredFields: RequiredFieldsReducer,
    dialogViewsState: DialogsViewsState,
    sidebarViewsState: SidebarViewsStateReducer,
    viewStateLoaded: ViewStateLoadedReducer,
    pageViewStack: PageViewsReducer,
  },
});

export type AppDispatch = typeof store.dispatch;

export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;